import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-logout-otp',
    templateUrl: './logout-otp.component.html',
    styleUrls: ['./logout-otp.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LogoutOtpComponent {}
